/**
 * @license
 * Copyright (c) Absa Group Limited, All Rights Reserved.
 */

import { Component, ViewEncapsulation, ViewChild, OnDestroy, ElementRef } from '@angular/core';

// Translate
import { TranslateService } from '@ngx-translate/core';

// Store
import { Store } from '@ngrx/store';
import * as fromStore from "../../../../../src/app/threshold/store/store";

// UI Actions
import * as thresholdActions from '../../store/actions/actions';
import { Subscription } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  encapsulation: ViewEncapsulation.Emulated,
  template: require('./download-mobile-app.component.html'),
  styles: [`
	.qr-code-custom { max-width: 335px; margin: 0 auto; padding: 1.5rem; border: 2px solid #ddd; border-radius: .25rem; }
  .custom-unique-code{ background-color: #f4f3f3; border: 1px solid #cac7c7; padding:14px 0;  border-radius: .25rem; font-size:0.95rem; }
  .link-custom { color: #fa551e; text-decoration: none; cursor: pointer; }
  .custom-button-width { padding: 9px 50px;  }
`]
})

export class DownloadMobileAppComponent implements OnDestroy {

  public subscription: Subscription;
  public manualDownloadUrl: string;

  /**
   * Localization language
   */
  private languageChangeSubscription: Subscription = new Subscription();
  private translationsSubscriptions: Subscription = new Subscription();

  /**
   * Localization location
   */
  private theSub: Subscription;
  private langChange: Subscription;
  private translateSub: Subscription;

  @ViewChild('manualAppUrlModal') manualAppUrlModal: ElementRef;

  constructor(
    private store: Store<fromStore.ThresholdState>,
    private translateService: TranslateService, /* translation service */
    private modalService: NgbModal,
    public translate: TranslateService) {

    setTimeout(() => {
      this.store.dispatch(new thresholdActions.ShowBannerAction());
      this.store.dispatch(new thresholdActions.SetColorAction('#fff'));
      this.store.dispatch(new thresholdActions.SetVariantAction('jumbo-variant-dark'));
      this.store.dispatch(new thresholdActions.SetBannerBackgroundAction(''));
      this.store.dispatch(new thresholdActions.SetSizeAction('sol-jumbo-h1'));
      this.store.dispatch(new thresholdActions.HideContextNavAction());
      this.store.dispatch(new thresholdActions.HideMenuAction());
      this.store.dispatch(new thresholdActions.HideProfileBannerAction());
      this.store.dispatch(new thresholdActions.SetDynamicMenuAction([]));
      this.store.dispatch(new thresholdActions.ShowMainMenuAction());
      this.getComponentTranslations();
    });

    this.languageChangeSubscription = this.translateService.onLangChange.subscribe((event: any) => { this.getComponentTranslations() });
  }


  private getComponentTranslations() {
    const viewTranslations = ['CELINE_DASHBOARD', 'CELINE_DOWNLOAD_APP_BUTTON_DOWNLOAD', 'CELINE_DOWNLOAD_APP_SCAN_QR_CODE_TITLE'];
    this.translationsSubscriptions.add(this.translateService.get(viewTranslations)
      .subscribe((translation) => {
        // Setup menu
        let mainNav: any[] = [
          { title: translation.CELINE_DASHBOARD, routerPath: '' },
          { title: translation.CELINE_DOWNLOAD_APP_BUTTON_DOWNLOAD, routerPath: 'download-mobile-app' }
        ];
        // Set manual enter url 
        this.manualDownloadUrl = `${JSON.parse(window['__CONFIGURATION'])['authUrl']}/mobile`;

        this.store.dispatch(new thresholdActions.SetBannerTitleAction(translation.CELINE_DOWNLOAD_APP_SCAN_QR_CODE_TITLE));
        this.store.dispatch(new thresholdActions.SetMainMenuAction(mainNav));
      })
    )
  }

  showManualAppUrl() {
    this.modalService.open(this.manualAppUrlModal, { keyboard: false, backdrop: 'static', windowClass: 'custom-modal' });
  }

  ngOnDestroy(): void {
    if (this.translationsSubscriptions) this.translationsSubscriptions.unsubscribe();
    if (this.languageChangeSubscription) this.languageChangeSubscription.unsubscribe();
    if (this.theSub) this.theSub.unsubscribe();
    if (this.langChange) this.langChange.unsubscribe();
    if (this.translateSub) this.translateSub.unsubscribe();
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/threshold/components/mobile/download-mobile-app.component.ts